<template>
  <div>
    <div class="d-md-flex justify-content-between align-items-center mb-4">
      <div class="cs-textstyle-page-subtitle">
        {{ formatSubcontinent(subcontinent.id) }}
      </div>
      <div class="count">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.868"
            height="15.533"
            viewBox="0 0 12.868 15.533"
          >
            <g transform="translate(-5.885 -1.104)">
              <path
                class="a"
                d="M6.434,15.533h0L1.884,10.984a6.435,6.435,0,0,1,9.1-9.1,6.434,6.434,0,0,1,0,9.1L6.435,15.533Zm0-12.153A2.987,2.987,0,1,0,9.421,6.369,2.991,2.991,0,0,0,6.433,3.381Z"
                transform="translate(5.885 1.104)"
              />
            </g>
          </svg>
          {{ cityCount | formatNumber }}
          {{ 'city' | pluralize(cityCount, 'cities') }}
        </span>
        <span
          ><i class="icons8-user-account"></i>{{ memberCount | formatNumber }}
          {{ 'member' | pluralize(memberCount) }}</span
        >
      </div>
    </div>
    <div class="card">
      <div v-for="country in subcontinent.countries" :key="country.id">
        <country-card :country="country"></country-card>
      </div>
    </div>
  </div>
</template>

<script>
import CountryCard from '@/components/cities/CountryCard';

export default {
  name: 'subcontinent-card',

  components: {
    CountryCard,
  },

  props: {
    subcontinent: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  computed: {
    memberCount() {
      return this.subcontinent && this.subcontinent.memberCount;
    },
    cityCount() {
      let total = 0;
      this.subcontinent &&
        this.subcontinent.countries.forEach((country) => {
          total = total + country.cityCount.aggregate.count;
        });
      return total;
    },
  },
  methods: {
    formatSubcontinent(subcontinent) {
      if (subcontinent === 'australia_new_zealand')
        return 'Australia and New Zealand';
      const result = subcontinent
        .split('_')
        .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
        .join(' ');
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.count span {
  font-size: 16px;
  margin-right: 10px;
  color: $grey-text;

  svg {
    height: 13px;
    margin-right: 3px;
    margin-bottom: 2px;
    path {
      fill: $grey-icon;
    }
  }

  i {
    margin-right: 7px;
    color: $grey-icon;
  }
}

.card {
  margin-bottom: 35px;
  padding: 20px 20px 15px;

  @include media-breakpoint-up(lg) {
    padding: 30px 25px 15px;
  }
}
</style>
